import { render, staticRenderFns } from "./finishUp.vue?vue&type=template&id=81b86df6&scoped=true&"
import script from "./finishUp.vue?vue&type=script&lang=js&"
export * from "./finishUp.vue?vue&type=script&lang=js&"
import style0 from "./finishUp.vue?vue&type=style&index=0&id=81b86df6&prod&scoped=true&lang=scss&"
import style1 from "./finishUp.vue?vue&type=style&index=1&id=81b86df6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81b86df6",
  null
  
)

export default component.exports